import { useState } from 'react';
import { LICENSE_STATUSES, PLAN_LIMIT_LABELS, daysUntil, type PlanLimits } from '@pos/core';
import { useLicenseState } from '../../services/license.ts';
import { Badge, Button, Card } from '../../ui/index.tsx';
import { ChangePasswordDialog } from '../auth/ChangePasswordDialog.tsx';
import { PayWithMp } from '../license/PayWithMp.tsx';

const dateFormat = new Intl.DateTimeFormat('es-AR', { dateStyle: 'long' });
const USAGE_KEY: Record<keyof PlanLimits, 'employees' | 'devices' | 'registers'> = {
  max_employees: 'employees',
  max_devices: 'devices',
  max_registers: 'registers',
};

/** Plan, vencimiento y uso (dueño). */
export function PlanCard() {
  const state = useLicenseState();
  const [changing, setChanging] = useState(false);

  return (
    <Card className="space-y-3">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <h2 className="font-semibold">Suscripción</h2>
        <Button variant="secondary" size="sm" onClick={() => setChanging(true)}>
          Cambiar mi contraseña
        </Button>
      </div>
      {state.kind !== 'ok' ? (
        <p className="text-sm text-slate-500">{state.kind === 'stale' ? 'No se pudo verificar hace muchos días: conectate a internet.' : 'Se consulta al conectarse.'}</p>
      ) : (
        <div className="space-y-2 text-sm">
          <p>
            Plan <strong>{state.license.plan.name}</strong>{' '}
            <Badge tone={state.status === 'activa' ? 'green' : state.status === 'en_gracia' ? 'amber' : 'red'}>{LICENSE_STATUSES[state.status].label}</Badge>
          </p>
          {state.schedule.noExpiry && <p className="text-slate-600">Sin vencimiento.</p>}
          {state.schedule.activeUntil && (
            <p className="text-slate-600">
              {state.schedule.trial ? 'Prueba gratis hasta' : 'Pagado hasta'} el {dateFormat.format(state.schedule.activeUntil)}
              {state.status === 'activa' && ` (${daysUntil(state.schedule.activeUntil)} días)`}.
            </p>
          )}
          <ul className="flex flex-wrap gap-x-4 gap-y-1 text-slate-600">
            {(Object.keys(PLAN_LIMIT_LABELS) as Array<keyof PlanLimits>).map((key) => {
              const limit = state.license.plan.limits[key];
              const used = state.license.usage[USAGE_KEY[key]];
              return (
                <li key={key}>
                  {PLAN_LIMIT_LABELS[key]}: {used}
                  {limit != null ? ` de ${limit}` : ' (sin límite)'}
                </li>
              );
            })}
          </ul>
        </div>
      )}
      {state.kind === 'ok' && !state.schedule.noExpiry && <PayWithMp planCode={state.license.plan.code} />}
      <ChangePasswordDialog open={changing} onClose={() => setChanging(false)} />
    </Card>
  );
}
